<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">在线车辆</font>
        </div>
      </div>
      <div class="headerB flex-between" v-if="dataLoading">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>在线车辆</p>
              </div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <div class="danwei">在<br />线</div>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.thisCountDan || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">辆</div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">在<br />运</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.thisCountLifang || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">m³</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keywordB" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameB" slot="prepend" style="width: 90px">
              <Option value="">查询全部</Option>
              <Option value="licensePlate">车牌号码</Option>
              <Option value="orgNameYunshu">运输单位</Option>
              <Option value="driverName">驾驶司机</Option>
              <Option value="projectName">在运项目</Option>
              <Option value="qingYunStartDistrictName">作业区县</Option>
              <Option value="qingYunStartStreetName">作业街道</Option>
            </Select>
          </Input>
        </li>
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keywordB" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameB" slot="prepend" style="width: 90px">
              <Option value="">查询全部</Option>
              <Option value="licensePlate">车牌号码</Option>
              <Option value="orgNameYunshu">运输单位</Option>
              <Option value="driverName">驾驶司机</Option>
              <Option value="projectName">在运项目</Option>
              <Option value="qingYunStartDistrictName">作业区县</Option>
              <Option value="qingYunStartStreetName">作业街道</Option>
            </Select>
          </Input>
        </li>
        			
        <li style="width: 90px">
          <Select v-model="searchMap.garbageName" placeholder="运输垃圾">
            <Option value="">运输垃圾</Option>
            <Option value="工程渣土">工程渣土</Option>
            <Option value="拆除垃圾">拆除垃圾</Option>
            <Option value="工程垃圾">工程垃圾</Option>
            <Option value="工程泥浆">工程泥浆</Option>
            <Option value="装修垃圾">装修垃圾</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.status" placeholder="行驶状态">
            <Option value="100">正在装车</Option>
            <Option value="200">正在行车</Option>
            <Option value="300">正在卸车</Option>
          </Select>
        </li>
        <li>
          <Button type="primary" @click="search" size="small" icon="ios-search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small" >导出联单</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="carNumber">
            <span>{{ row.carNumber }}车</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="garbageNumber">
            <span>{{ row.garbageNumber }}m³</span>
          </template>

                  <!--分割区-->
          <template slot-scope="{ row }" slot="projectType">
            <span v-if="row.projectType == 100">工地单</span>
            <span v-if="row.projectType == 200">整车单</span>
            <span v-if="row.projectType == 300">零散单</span>
            <span v-if="row.projectType == 400">堆放单</span>
            <span v-if="row.projectType == 500">水运单</span>
            <span v-if="row.projectType == 600">车厢单</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="emissionTime">
            <span class="oe1">{{ $timeFmt(row.emissionTime, "YYYY-MM-DD") }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="status">
            <Tag color="red" v-if="row.status == 100">{{ $state["electronicbill"][row.status] }}</Tag>
            <Tag color="blue" v-if="row.status == 200">{{ $state["electronicbill"][row.status] }}</Tag>
            <Tag color="cyan" v-if="row.status == 300">{{ $state["electronicbill"][row.status] }}</Tag>
            <Tag color="cyan" v-if="row.status == 400">{{ $state["electronicbill"][row.status] }}</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <div class="flex-center">
              <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)" style="margin-left: 5px">详情</Button>
            </div>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <!--联单详情-->
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "在线车辆",
          key: "licensePlate",
          width: 100,
          align: "center",
        },
        {
          title: "车辆车型",
          key: "carName",
          width: 120,
          align: "center",
        },
        {
          title: "运输单位",
          key: "orgNameYunshu",
          width: 160,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "驾驶司机",
          key: "driverName",
          width: 90,
          align: "center",
        },
        {
          title: "作业区县",
          key: "qingYunStartDistrictName",
          width: 110,
          align: "center",
        },
        {
          title: "作业街道",
          key: "qingYunStartStreetName",
          width: 120,
          align: "center",
        },
        {
          title: "在运联单",
          key: "NO",
          width: 140,
          align: "center",
          ellipsis: true,
          tooltip: true,
        },
        {
          title: "在运项目",
          key: "projectName",
          minWidth: 200,
          align: "left",
          sortable: true,
          ellipsis: true,
          tooltip: true,
        },
        {
          title: "来源",
          key: "projectType",
          width: 60,
          align: "center",
          slot: "projectType",
        },
        {
          title: "运输垃圾",
          key: "garbageTypeName",
          width: 150,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            var html1 = row.garbageTypeName;
            if (!this.$isblank(row.garbageName)) {
              html1 = html1 + "(" + row.garbageName + ")";
            }
            return h("span", html1);
          },
        },
        {
          title: "在运数量",
          key: "garbageNumber",
          width: 100,
          align: "center",
          slot: "garbageNumber",
        },
        {
          title: "装车起始",
          key: "emissionTime",
          width: 130,
          align: "center",
          slot: "emissionTime",
        },
        {
          title: "行驶状态",
          key: "status",
          width: 80,
          align: "center",
          fixed: "right",
          slot: "status",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 70,
          slot: "action",
          align: "center",
        },
      ]),
      //搜索配置项(searchMap)@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "",
        keywordA: "",
        likeNameB: "",
        garbageType: "",
        garbageName: "",
        status: "",
        examinePingtai: "",
        examinePaifangOrg: "",
        examineJieshouOrg: "",
        open_type: "",
        daterange: "",
        pageNo: 1,
        pageSize: 25,
        searchType: 600,
        code: "",
        level: "",
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    //请求数据
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getElectronicbillList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },

        // +----------------------------------------------------------------------
        // | 导出excel
        // +----------------------------------------------------------------------
        uploadExcel() {
            this.$loading(true);
            this.searchMap.ids = this.selectedRows;
            var obj1 = this.searchTemp;
            var obj2 = this.searchMap;
        
            this.searchMap = { ...obj2, ...obj1 };
            
            var parameter = this.searchMap;
            var url = "/zxbigscreen/Electronicbill/uploadExcel";
            var fileName = "工地联单.xlsx";
            this.$downLoad(url,parameter,fileName);
            this.$loading(false);
        },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.getList();
    },
  },
};
</script>
